<template>
    <div id="workOrderAdd">
        <van-form @submit="onSubmit" label-width="100px" input-align="right">
            <van-field readonly clickable required name="type" :value="(workOrderTypeList.find(d => d.value == form.type)||{}).label" label="工单类型" placeholder="点击选择>" @click="item => { showWorkOrderType = true }" :rules="[{ required: true, message: '请选择工单类型' }]" />
            <!-- <van-field required name="客户类型" label="类型">
                <template #input>
                    <van-radio-group v-model="customerType" direction="horizontal">
                        <van-radio name="1">管家</van-radio>
                        <van-radio name="0">租客</van-radio>
                    </van-radio-group>
                </template>
            </van-field> -->
            <van-field readonly clickable required :value="form.customerName" name="客户" label="客户" placeholder="点击搜索客户>" @click="item => {if(!$route.query.customerId){showCustomer = true;searchValueCustomer='';}}" maxlength="11" :rules="[{ required: true, message: '请选择客户' }]" />
            <van-field readonly clickable required name="house" :value="form.address" label="房源地址" placeholder="点击选择房源>" @click="form.customerId?showHouse = true:$toast('请先选择客户')" :rules="[{ required: true, message: '请选择房源' }]" />
            <van-field name="roomId" label="房间">
                <template #input>
                    <van-radio-group v-model="form.roomId" direction="horizontal">
                        <van-radio name="">整套</van-radio>
                        <van-radio v-for="(item,index) in roomList" :key="item.no" :name="item.id">{{item.no}}</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-for="(item,index) in form.serviceTypes" :key="index" readonly clickable :required="index==0?true:false" :value="item.typeNameOne+'-'+item.typeNameTwo" :label="index==0?'服务类型':''" placeholder="点击选择服务类型>" :right-icon="form.serviceTypes.length<3&&index==0?'add':'delete'" @click-input="showServiceType = true;serviceIndex = index;serviceTypeList = serviceTypeList.slice(0)" @click-right-icon="form.serviceTypes.length<3&&index==0?addServiceType(index):deleteServiceType(index)" :rules="validServiceType(item)" />
            <van-field v-model="form.description" rows="2" autosize label="描述" type="textarea" maxlength="50" placeholder="请输入描述" show-word-limit />
            <div class="field">照片</div>
            <div class="body body1">
                <van-uploader :before-read="beforeRead" :after-read="item => {imageList.pop();imageList.push({
            url: upload_qiniu_addr + item.file.key,
            isImage: true
          })}" v-model="imageList" :max-count="10" />
            </div>
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit">保存</van-button>
            </div>
        </van-form>
        <!-- 工单类型 -->
        <van-popup v-model="showWorkOrderType" position="bottom">
            <van-picker show-toolbar :columns="workOrderTypeList" value-key="value" @confirm="changeWorkOrderType" @cancel="showWorkOrderType = false">
                <template #option='item'>
                    {{item.label}}
                </template>
            </van-picker>
        </van-popup>
        <!-- 客户搜索 -->
        <transition name="van-slide-right">
            <div v-show="showCustomer" class="search">
                <form action="/">
                    <van-search v-model="searchValueCustomer" shape="round" show-action placeholder="请输入手机号搜索" @input="onSearchCustomer" @search="onSearchCustomer" @cancel="showCustomer = false" />
                </form>
                <van-cell v-for="customer in customerList" :key="customer.id" :title="customer.name + '-' + customer.phone" icon="user-o" @click="changeCustomer(customer)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueCustomer&&!customerList.length">暂无数据</div>
            </div>
        </transition>
        <!-- 房源地址 -->
        <transition name="van-slide-right">
            <div v-show="showHouse" class="search">
                <form action="/">
                    <van-search v-model="searchValueHouse" shape="round" show-action placeholder="请输入房源搜索" @input="onSearchHouse" @search="onSearchHouse" @cancel="showHouse = false" />
                </form>
                <van-cell v-for="house in houseList" :key="house.id" v-show="house.address.indexOf(searchValueHouse)>-1" :title="house.address" icon="user-o" @click="changeHouse(house)"></van-cell>
                <!-- <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueHouse&&!houseList.length">暂无数据</div> -->
            </div>
        </transition>
        <!-- <van-popup v-model="showHouse" position="bottom">
            <van-picker show-toolbar :columns="houseList" value-key="value" @confirm="changeHouse" @cancel="showHouse = false">
                <template #option='item'>
                    {{item.address}}
                </template>
            </van-picker>
        </van-popup> -->
        <!-- 类型 -->
        <van-popup v-model="showServiceType" position="bottom">
            <van-picker show-toolbar title="标题" :columns="serviceTypeList" @confirm="changeServiceType" @cancel="showServiceType = false" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate, getNdaysDate } from "@/utils/index";
import { validPhone } from "@/utils/validate";
import { compress, compressAccurately } from "image-conversion";
import request from "@/utils/request";
import {
    requestWorkOrderCustomer,
    requestWorkOrderHouse,
    requestWorkOrderCreate,
    requestWorkOrderServiceType,
    requestQiniuToken,
    requestWorkOrderHouseRoom,
} from "@/api";
export default {
    name: "workOrderAdd",
    data() {
        return {
            form: {
                type: "",
                houseId: "",
                houseNumber: "",
                address: "",
                roomId: "",

                customerId: "",
                customerName: "",
                customerPhone: "",
                images: [],
                serviceTypes: [
                    {
                        typeNameOne: "",
                        typeNameTwo: "",
                    },
                ],
                description: "",
            },
            showWorkOrderType: false,
            // customerType: "1",
            saveLoad: false,
            searchLoad: false,
            //客户搜索
            showCustomer: false,
            searchValueCustomer: "",
            customerList: [], //搜索客户
            //房源
            showHouse: false,
            searchValueHouse: "",
            houseList: [], //搜索房源
            roomList: [],

            //类型
            showServiceType: false,
            serviceTypeList: [],
            serviceIndex: 0,
            imageList: [],
            qiniuData: {},
        };
    },
    computed: {
        ...mapState(["workOrderTypeList", "upload_qiniu_addr"]),
    },
    created() {},
    mounted() {
        this.getQiniuToken();
    },
    methods: {
        validServiceType(item) {
            console.log(item);
            return [
                {
                    item,
                    validator: (value, rule) => {
                        return Boolean(item.typeNameOne);
                    },
                    message: "请选择服务类型",
                },
            ];
        },
        changeWorkOrderType(item) {
            this.form.type = item.value;
            this.showWorkOrderType = false;
            this.form.serviceTypes = [
                {
                    typeNameOne: "",
                    typeNameTwo: "",
                },
            ];
            requestWorkOrderServiceType({
                type: this.form.type,
            }).then((res) => {
                (res.data || []).forEach((d) => {
                    d.text = d.typeNameOne;
                    let children = [];
                    (d.typeNameTwo || []).forEach((e) => {
                        children.push({ text: e });
                    });
                    d.children = children;
                    if (!d.children.length) {
                        d.children.push({ text: "其他" });
                    }
                });
                this.serviceTypeList = res.data || [];
            });
        },
        //搜索客户
        onSearchCustomer() {
            if (!this.searchValueCustomer) return;
            this.searchLoad = true;
            this.customerList = [];
            requestWorkOrderCustomer({
                customerInfo: this.searchValueCustomer,
                // customerType: this.customerType,
            }).then((res) => {
                this.searchLoad = false;
                this.customerList = res.data;
            });
        },
        //选择客户
        changeCustomer(item) {
            this.form.customerId = item.id;
            this.form.customerName = item.name;
            this.form.customerPhone = item.phone;
            this.form.houseId = "";
            this.form.houseNumber = "";
            this.form.address = "";
            requestWorkOrderHouse({
                customerId: item.id,
                customerType: "2",
            }).then((res) => {
                this.houseList = res.data || [];
            });
            this.showCustomer = false;
        },
        //搜索房源
        onSearchHouse() {
            // this.searchLoad = true;
        },
        //选择房源
        changeHouse(item) {
            this.form.houseId = item.id;
            this.form.houseNumber = item.houseNumber;
            this.form.address = item.address;
            this.showHouse = false;
            requestWorkOrderHouseRoom(item.id).then((res) => {
                this.roomList = res.data || [];
            });
        },
        //类型
        addServiceType() {
            this.form.serviceTypes.push({
                typeNameOne: "",
                typeNameTwo: "",
            });
        },
        deleteServiceType(index) {
            this.form.serviceTypes.splice(index, 1);
        },
        changeServiceType(item, index) {
            this.form.serviceTypes[this.serviceIndex].typeNameOne =
                item[0] || "";
            this.form.serviceTypes[this.serviceIndex].typeNameTwo =
                item[1] || "";
            this.showServiceType = false;
        },
        //照片
        //获取七牛token
        getQiniuToken() {
            requestQiniuToken()
                .then((res) => {
                    this.qiniuData.token = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //图片上传前校验，压缩
        beforeRead(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isLt8M = file.size / 1024 / 1024 < 8;
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isJPG && !isPNG) {
                this.$toast.fail("图片只能是 JPG/PNG 格式！");
                return false;
            }
            if (!isLt10M) {
                this.$toast.fail("图片大小不能超过 10MB!");
                return false;
            }
            this.qiniuData.key = Date.now() + file.name;
            return new Promise((resolve, reject) => {
                compressAccurately(file, 400).then((fileMin) => {
                    let data = new FormData();
                    data.append("token", this.qiniuData.token);
                    data.append("key", this.qiniuData.key);
                    data.append("file", fileMin);
                    request({
                        url: this.$store.state.qiniuUpload,
                        method: "post",
                        processData: false,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        data: data,
                    })
                        .then((res) => {
                            let newFile = fileMin;
                            newFile.key = res.key;
                            resolve(newFile);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                });
            });
        },
        //提交
        onSubmit() {
            console.log(this.form);
            this.form.images = [];
            this.imageList.forEach((d) => {
                this.form.images.push(d.url);
            });
            this.saveLoad = true;
            requestWorkOrderCreate(this.form)
                .then((res) => {
                    this.$toast.success({
                        message: "新增成功",
                        overlay: true,
                        onClose: () => {
                            this.$router.back();
                            // this.$router.push({ path: "destineList" });
                        },
                    });
                    this.saveLoad = false;
                })
                .catch((err) => {
                    this.saveLoad = false;
                    console.log(err);
                });
        },
        //校验
        validPhone(val) {
            return validPhone(val);
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
/deep/.van-field__error-message {
    text-align: right;
}
#workOrderAdd {
    background: #fff;
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    .van-search {
        /deep/i {
            line-height: 0.84rem;
        }
        /deep/input {
            border: none;
        }
    }
}
.field {
    background-color: #fff;
    // border-bottom: 0.02667rem solid #ebedf0;
    .error {
        // position: absolute;
        padding: 0 0.42667rem 0.131rem 0;
        transform: translateY(-0.2rem);
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
.field {
    padding: 0.26667rem 0.42667rem;
    background: #fff;
    font-size: 0.3rem;
    line-height: 0.64rem;
    color: #323232;
    text-align: left;
    position: relative;
    ::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0.42667rem;
        bottom: 0;
        left: 0.42667rem;
        border-bottom: 0.02667rem solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
.body {
    padding: 0.1rem;
    text-align: left;
    .van-uploader {
        // margin: 0.2rem;
        /deep/.van-uploader__preview-image {
            border: 1px solid #ebedf0;
        }
    }
    .picCard {
        display: inline-block;
        margin: 0.2rem;
        width: 2.2rem;
        .text {
            text-align: center;
            .van-field {
                padding: 0;
                /deep/input {
                    text-align: center;
                }
            }
        }
        .textBorder {
            /deep/.van-field__body {
                border: 1px solid $border-color;
                border-radius: 0.1rem;
                overflow: hidden;
            }
        }
    }
}
</style>
